import { createPinia } from "pinia";

// Create and export pinia instance
export const pinia = createPinia();

// Export all stores
export { useAuthStore } from "./auth";
export { usePersonStore } from "./person";
export { useInvestmentStore } from "./investment";
export { useInvestorStore } from "./investor";
export { useRoleStore } from "./role";
export { useFileStore } from "./file";
export { useMfaStore } from "./mfa";
export { usePersonMessagePreferencesStore } from "./personMessagePreferences";

// Re-export for convenience
export { useAuthStore as useLoginStore } from "./auth";

// For backward compatibility, you can also export a default
export default pinia;
